import { useEffect, useState } from "react";

/**
 * Lê o flag de manutenção planejada (frontend/public/manutencao.json).
 * É um arquivo ESTÁTICO servido pelo Vite — continua acessível mesmo com o
 * backend derrubado, então serve pra avisar "estamos atualizando, aguarde".
 *
 * Diferente do banner VERMELHO de "servidor offline" (useBackendStatus), que
 * dispara sozinho quando o backend não responde (queda real). Este aqui é
 * AMARELO e só liga quando NÓS trocamos ativo -> true antes de uma atualização.
 */
export interface ManutencaoInfo {
  ativo: boolean;
  mensagem: string;
}

export function useManutencao(): ManutencaoInfo | null {
  const [info, setInfo] = useState<ManutencaoInfo | null>(null);

  useEffect(() => {
    let vivo = true;

    async function checar() {
      try {
        // cache-buster + no-store: precisamos do valor mais recente sempre.
        const r = await fetch(`/manutencao.json?t=${Date.now()}`, { cache: "no-store" });
        if (!r.ok) {
          if (vivo) setInfo(null);
          return;
        }
        const data = (await r.json()) as ManutencaoInfo;
        if (vivo) setInfo(data && typeof data.ativo === "boolean" ? data : null);
      } catch {
        // arquivo ausente / rede — não trava nada; só não mostra o aviso.
        if (vivo) setInfo(null);
      }
    }

    checar();
    const id = setInterval(checar, 8000);
    return () => {
      vivo = false;
      clearInterval(id);
    };
  }, []);

  return info;
}
